var _g, _g2, _g3, _g4, _g5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg10N(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 412,
    height: 307,
    viewBox: "0 0 412 307",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_6_1102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.996 227.122C143.287 227.151 166.505 263.402 166.505 277.491C166.505 284.256 163.818 290.745 159.034 295.529C154.25 300.313 147.761 303 140.996 303C134.231 303 127.742 300.313 122.958 295.529C118.175 290.745 115.487 284.256 115.487 277.491C115.487 263.402 138.707 227.097 140.996 227.122Z",
    fill: "#42A0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.546 287.027C124.095 287.806 127.335 284.6 128.782 279.866C130.229 275.133 129.336 270.663 126.787 269.884C124.238 269.105 120.999 272.311 119.552 277.045C118.104 281.778 118.997 286.248 121.546 287.027Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.298 227.122C283.589 227.151 306.807 263.402 306.807 277.491C306.807 284.256 304.12 290.745 299.336 295.529C294.552 300.313 288.063 303 281.298 303C274.533 303 268.044 300.313 263.26 295.529C258.477 290.745 255.789 284.256 255.789 277.491C255.789 263.402 279.009 227.097 281.298 227.122Z",
    fill: "#42A0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.848 287.027C264.397 287.806 267.637 284.6 269.084 279.866C270.531 275.133 269.638 270.663 267.089 269.884C264.54 269.105 261.301 272.311 259.854 277.045C258.406 281.778 259.299 286.248 261.848 287.027Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.852 179.295C208.143 179.324 231.361 215.575 231.361 229.664C231.361 236.429 228.673 242.918 223.89 247.702C219.106 252.485 212.617 255.173 205.852 255.173C199.087 255.173 192.598 252.485 187.814 247.702C183.031 242.918 180.343 236.429 180.343 229.664C180.343 215.575 203.563 179.27 205.852 179.295Z",
    fill: "#42A0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.402 239.2C188.951 239.979 192.191 236.773 193.638 232.039C195.085 227.305 194.192 222.836 191.643 222.057C189.094 221.278 185.855 224.484 184.408 229.217C182.96 233.951 183.853 238.42 186.402 239.2Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_6_1102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.4871 186.295C75.2648 186.315 60.3896 181.748 47.8011 173.19C36.3708 165.443 27.2385 154.759 21.3639 142.263C15.4893 129.767 13.0894 115.919 14.4163 102.174C15.7433 88.4297 20.7481 75.2965 28.9048 64.1548C37.0615 53.0131 48.0689 44.2743 60.7701 38.8568C70.1664 34.8588 80.2757 32.8075 90.4871 32.8268C93.468 32.8269 96.4463 32.9998 99.4071 33.3448C97.6809 37.1194 96.3602 41.0665 95.4671 45.1198C94.5492 49.3033 94.0869 53.5738 94.0881 57.8568C94.069 69.6099 97.578 81.0983 104.161 90.8348C108.405 97.1147 113.813 102.523 120.093 106.767C123.249 108.899 126.605 110.72 130.112 112.205C137.375 115.279 145.184 116.855 153.071 116.84C157.634 116.841 162.182 116.316 166.624 115.275C165.576 129.709 160.46 143.551 151.869 155.197C149.09 158.965 145.974 162.472 142.559 165.676C128.467 178.938 109.839 186.314 90.4871 186.295Z",
    fill: "#713FFD"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_6_1102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.0538 99.0074C94.1916 83.5764 99.5265 61.5624 88.9695 49.8377C78.4126 38.1131 55.9615 41.1176 38.8237 56.5486C21.6859 71.9795 16.3511 93.9935 26.908 105.718C37.465 117.443 59.916 114.438 77.0538 99.0074Z",
    fill: "#A586FC"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_6_1102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.9861 13L55.5511 19.2L62.4861 21.5L55.5511 23.8L52.9861 30L50.4211 23.8L43.4861 21.5L50.4211 19.2L52.9861 13Z",
    fill: "url(#paint0_linear_6_1102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.486 160L169.646 165.11L175.486 167L169.646 168.89L167.486 174L165.326 168.89L159.486 167L165.326 165.11L167.486 160Z",
    fill: "url(#paint1_linear_6_1102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.489 32.6052L137.03 37.2472L143.344 37.6252L138.066 41.1112L137.322 46.902L133.781 42.2497L127.467 41.8716L132.745 38.3856L133.489 32.6052Z",
    fill: "url(#paint2_linear_6_1102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1838 148.601L11.0048 152.196L16.9482 151.602L12.3921 155.464L12.3231 160.707L8.51299 157.109L2.56965 157.704L7.1265 153.843L7.1838 148.601Z",
    fill: "url(#paint3_linear_6_1102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.152 84.0383L125.952 84.8895L123.468 89.2421L123.142 84.2408L119.741 81.6349L123.943 80.7863L126.427 76.4335L126.75 81.4344L130.152 84.0383Z",
    fill: "url(#paint4_linear_6_1102)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_df_6_1102)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_6_1102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.781 233.765C253.848 233.92 251.895 233.999 249.924 234H112.4C102.934 234.035 93.5536 232.201 84.7978 228.603C76.0419 225.005 68.0826 219.714 61.3765 213.032C54.6703 206.351 49.3492 198.412 45.7185 189.669C42.0877 180.927 40.2187 171.554 40.2188 162.087C40.2187 152.621 42.0877 143.248 45.7185 134.506C49.3492 125.763 54.6703 117.824 61.3765 111.143C68.0826 104.461 76.0419 99.17 84.7978 95.5718C93.5536 91.9737 102.934 90.1397 112.4 90.175H163.676C180.3 53.6 218.587 28 263.16 28C322.987 28 371.487 74.115 371.487 131C371.487 187.885 322.987 234 263.16 234C260.68 234 258.22 233.922 255.781 233.765Z",
    fill: "url(#paint5_linear_6_1102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.16 233C270.446 233 277.727 232.302 284.8 230.926C291.694 229.585 298.474 227.584 304.952 224.978C311.313 222.42 317.448 219.254 323.186 215.568C328.869 211.917 334.213 207.725 339.07 203.107C343.925 198.49 348.333 193.411 352.171 188.009C356.045 182.557 359.373 176.728 362.061 170.686C364.798 164.532 366.9 158.093 368.309 151.547C369.754 144.831 370.487 137.917 370.487 131C370.487 124.082 369.754 117.169 368.309 110.452C366.9 103.906 364.798 97.4673 362.061 91.3142C359.373 85.2716 356.045 79.4433 352.171 73.991C348.333 68.5893 343.925 63.5095 339.07 58.8928C334.213 54.2752 328.869 50.0829 323.186 46.4323C317.448 42.7461 311.313 39.5801 304.952 37.0221C298.474 34.4165 291.694 32.4154 284.8 31.0742C277.727 29.6979 270.446 29 263.16 29C241.789 29 221.15 34.9523 203.473 46.2135C194.953 51.6418 187.296 58.1939 180.716 65.6878C174.095 73.2291 168.668 81.6069 164.586 90.5885L164.319 91.1747H163.675H112.4C102.826 91.1747 93.5395 93.0495 84.7977 96.747C80.5961 98.5242 76.5435 100.724 72.7526 103.285C68.9974 105.822 65.4662 108.735 62.257 111.945C59.0478 115.154 56.1342 118.685 53.5973 122.44C51.0362 126.231 48.8365 130.284 47.0594 134.485C43.3619 143.227 41.4871 152.514 41.4871 162.087C41.4871 171.661 43.3619 180.948 47.0594 189.689C48.8365 193.891 51.0362 197.944 53.5973 201.735C56.1342 205.49 59.0478 209.021 62.257 212.23C65.4662 215.439 68.9974 218.353 72.7526 220.89C76.5435 223.451 80.5961 225.651 84.7977 227.428C93.5395 231.125 102.826 233 112.4 233H249.924C251.847 233 253.791 232.922 255.701 232.768L255.773 232.762L255.845 232.767C258.265 232.922 260.726 233 263.16 233ZM263.16 234C260.68 234 258.219 233.921 255.781 233.765C253.851 233.92 251.895 234 249.924 234H112.4C72.6836 234 40.4871 201.803 40.4871 162.087C40.4871 122.371 72.6836 90.1747 112.4 90.1747H163.675C180.3 53.5954 218.585 28 263.16 28C322.987 28 371.487 74.1151 371.487 131C371.487 187.885 322.987 234 263.16 234Z",
    fill: "white",
    fillOpacity: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6_1102",
    x: 111.487,
    y: 175.295,
    width: 199.32,
    height: 131.705,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_6_1102"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_6_1102",
    x: 10.0605,
    y: 28.8267,
    width: 160.563,
    height: 161.468,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_6_1102"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_6_1102",
    x: 1.48804,
    y: 22.6855,
    width: 112.902,
    height: 110.185,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_6_1102"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_6_1102",
    x: 0.56958,
    y: 11,
    width: 176.917,
    height: 165,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_6_1102"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_df_6_1102",
    x: 20.2188,
    y: 0,
    width: 391.269,
    height: 266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_1102"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_1102",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect2_foregroundBlur_6_1102"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_6_1102",
    x: 20.2188,
    y: 0,
    width: 391.269,
    height: 266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.501961 0 0 0 0 0.501961 0 0 0 0 0.501961 0 0 0 0.302 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_1102"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_1102",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_1102",
    x1: 52.9861,
    y1: 13,
    x2: 52.9861,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B38FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7EFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_1102",
    x1: 167.486,
    y1: 160,
    x2: 167.486,
    y2: 174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B38FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7EFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_1102",
    x1: 133.49,
    y1: 32.6048,
    x2: 137.323,
    y2: 46.9016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B38FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7EFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_1102",
    x1: 7.18887,
    y1: 148.599,
    x2: 12.3282,
    y2: 160.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B38FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7EFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6_1102",
    x1: 130.151,
    y1: 84.0393,
    x2: 119.741,
    y2: 81.6359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B38FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7EFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6_1102",
    x1: 174.382,
    y1: 53.9561,
    x2: 240.424,
    y2: 245.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.596
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7F7",
    stopOpacity: 0.204
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg10N);
export default __webpack_public_path__ + "static/media/10n.51a6804963930a545c722a5223cee7d1.svg";
export { ForwardRef as ReactComponent };